import React, { useEffect, useState } from "react";
// import SubmeterPlanilha from "../../components/SubmeterPlanilha/SubmeterPlanilha";
import SubmeterPlanilhaNfe from "../../components/SubmeterPlanilhaNfe/SubmeterPlanilhaNfe";
import ListaArquivosNfe from "../../components/ListaArquivosNfe/ListaArquivosNfe";
import { LoteProcessamentoStyle } from "./style";

function LoteProcessamento() {
  const [tipoAssinaturaUsuario, setTipoAssinaturaUsuario] = useState("");

  useEffect(() => {
    const usuarioData = localStorage.getItem("usuario");
    if (usuarioData) {
      const parsedUser = JSON.parse(usuarioData);
      setTipoAssinaturaUsuario(parsedUser.tipoAssinatura);
    }
  }, []);

  return (
    <>
      <div className="page-container-style">
        <LoteProcessamentoStyle>
          <h2 className="page-title">Lotes de Processamento</h2>
          {/* <SubmeterPlanilha /> */}
          {tipoAssinaturaUsuario === "POS_PAGA" ? <SubmeterPlanilhaNfe /> : null}
          {tipoAssinaturaUsuario === "POS_PAGA" ? <ListaArquivosNfe /> : null}
        </LoteProcessamentoStyle>
      </div>
    </>
  );
}

export default LoteProcessamento;
